import type { ReactElement, ReactNode } from 'react';
import cx from 'clsx';
import { Box, Sprinkles } from '@ff-it/ui';
import * as style from './style.css';
import { InvoiceDirection } from 'modules/invoicing/common/types';

type SummaryContainerProps = {
  direction: InvoiceDirection;
  children?: ReactNode;
  testId?: string;
  stackable?: boolean;
} & Sprinkles;

export function SummaryContainer({ direction, children, stackable, ...rest }: SummaryContainerProps): ReactElement {
  return (
    <Box className={cx(style.container[direction], stackable && style.stackable)} {...rest}>
      {children}
    </Box>
  );
}

type SummaryFieldProps = {
  label: ReactNode;
  children: ReactNode;
  testId?: string;
} & Sprinkles;

export function SummaryField({ label, children, testId, ...rest }: SummaryFieldProps): ReactElement {
  return (
    <Box className={style.cell}>
      <Box className={style.label}>{label}</Box>
      <Box testId={testId} ml="3" {...rest}>
        {children}
      </Box>
    </Box>
  );
}
